import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  InputBase,
  Paper,
  Popover,
  Badge,
  Button
} from "@mui/material";
import { BorderBottom, Menu as MenuIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { Link as MUILink } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import "./Header.css";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { useSelector } from "react-redux";
import { getAllNotifications } from "../../redux/reducers/notificationReducer";
import { useDispatch } from "react-redux";
import ProfileScreen from "../ProfileScreen";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useLocation } from "react-router-dom";
import NotificationPanel from "../../components/notification/Notification";
import GradientButton from "../../components/common/GradiantButton";
import { Chip } from "@mui/material";
import LoginModal from "../../components/common/LoginModal";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";



function Header({ onDrawerToggle, currentPath }) {
  const userData = useSelector((state) => state.user);
  const [searchTerm, setSearchTerm] = useState("");
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get("ref");


  const isHome = location.pathname === "/";

  const [contactAnchor, setContactAnchor] = useState(null);
  const isMobile = useMediaQuery("(max-width:768px)");
  const [openContactMobile, setOpenContactMobile] = useState(false);


  const handleContactClick = (event) => {
    setContactAnchor(event.currentTarget);
  };

  const handleContactClose = () => {
    setContactAnchor(null);
  };

  const openContact = Boolean(contactAnchor);


  const userId = useSelector((state) => state.user.userId);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const likedItems = useSelector((state) => state.favorites.items || []);
  const theme = useSelector((data) => data.themeValue.colors)
  const themeMode = useSelector((state) => state.themeValue.theme);
  const notifications = useSelector((state) => state.notification.list);
  const unReadNotifications = notifications.filter(notification => notification.status === 'Unread');

  // const [scrolled, setScrolled] = useState(false);

  const [openLoginModal, setOpenLoginModal] = useState(false);


  const handleClick = () => {
    if (!isAuthenticated) {
      // User not logged in → show login modal
      setOpenLoginModal(true);
    } else if (isAuthenticated && !userData?.isVerified) {
      // User logged in but email not verified → show alert/snackbar
      alert("Please verify your email to post a property.");
      // OR you can navigate them to EditProfile page to verify email
      navigate("/myprofile");
    } else if (isAuthenticated && userData?.isVerified) {
      // User logged in and verified → allow posting property
      navigate("/post-your-property");
    }
  };

  const handleRequirementClick = () => {
    if (isAuthenticated) {

      navigate("/post-requirement");
    } else {

      setTimeout(() => {
        setOpenLoginModal(true);
      }, 200);
    }
  };
  useEffect(() => {
    if (userId) {
      dispatch(getAllNotifications(userId));
    }
  }, [userId, dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      setOpenLoginModal(false);
    }
  }, [isAuthenticated]);


  const handleSearch = (e) => {
    if (e.key === "Enter" || e.type === "click") {
      navigate("/search-properties", {
        state: { keyword: searchTerm },
      });
    }
  };

  const handleNotificationClick = (event) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchor(null);
  };

  const likeCount = likedItems.length;
  const unreadCount = unReadNotifications.length;

  const notificationOpen = Boolean(notificationAnchor);
  //   const buttonBg = !scrolled ? "#fff" : "primary.main";
  // const buttonColor = !scrolled ? "black" : "white";

  if (!isAuthenticated) {
    return (
      //      <AppBar
      //   position="fixed"
      //   elevation={0}
      //   sx={{
      //     padding: { xs: "0px", sm: "5px" },
      //     paddingTop: "4px",
      //     paddingBottom: "4px",

      //     backgroundColor: isHome && !scrolled ? "transparent" : "white",
      //     borderBottom: isHome && !scrolled ? "none" : "2px solid #bfdbfe",
      //     boxShadow:
      //       isHome && !scrolled
      //         ? "none"
      //         : "0 4px 16px rgba(0,0,0,0.15)",

      //     zIndex: 1300,
      //     transition: "all 0.3s ease",
      //   }}
      // >
      <AppBar
        position="fixed"
        elevation={3}
        sx={{
          padding: { xs: "0px", sm: "5px" },
          paddingTop: { xs: "4px" },
          paddingBottom: { xs: "4px" },
        }}
        style={{
          background: "white",
          borderBottom: "2px solid #bfdbfe",
          boxShadow: themeMode === "light"
            ? "0 4px 16px rgba(0, 0, 0, 0.25)"
            : "0 4px 16px rgba(239, 237, 237, 0.1)",
        }}
      >
        <Toolbar
          sx={{
            p: 0,
            pl: { xs: 2, sm: 0 },
            minHeight: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Logo & Text */}
            <Box sx={{ display: "flex", alignItems: "center"}}>
              <Box
                component="img"
                src="/Jemins Letter Head.png"
                alt="Jemins Logo"
                sx={{
                  height: { xs: 65, sm: 80 },
                  width: "auto",
                  objectFit: "contain",
                }}
              />

              <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                <MUILink
                  component="button"
                  underline="none"
                  onClick={() => {
                    window.location.href = "/";
                  }}
                  sx={{
                    color: "black",
                    fontSize: { xs: "1.5rem", sm: "1.7rem" },
                    fontWeight: 700,
                    fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
                    letterSpacing: "-0.02em",
                    textAlign: "left",
                  }}
                >
                  JEMINS
                </MUILink>

                <Typography
                  sx={{
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#666",
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                  }}
                >
                  Your Property Partner
                </Typography>
              </Box>
            </Box>

            {currentPath === "/search-properties" && (
              <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Paper
                  component="div"
                  sx={{
                    display: { xs: "none", sm: 'flex' },
                    alignItems: 'center',
                    px: 2,
                    py: 0.5,
                    width: { xs: "85%", sm: "65%", md: "55%" },
                    borderRadius: "15px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    border: "1px solid #f0f0f0",
                    backgroundColor: "white",
                    transition: "all 0.2s ease",
                    "&:focus-within": {
                      boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
                      border: "1px solid #e0e0e0",
                    }
                  }}
                >
                  <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
                  <InputBase
                    placeholder="Search properties by location, area, or name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch(e)}
                    sx={{
                      // ml: 1,
                      flex: 1,
                      fontSize: "0.95rem",
                      "& .MuiInputBase-input": {
                        padding: "8px 0",
                      }
                    }}
                  />
                  {/* Search Button with Loading State */}

                  <GradientButton
                    text="Search"
                    onClick={handleSearch}
                    // disabled={!searchTerm.trim()}
                    width={100}
                    height={35}
                  />

                </Paper>
              </Box>
            )}
            {/* Right Actions */}

            {/* Post Property with FREE badge */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {/* ================= MOBILE VIEW ================= */}
              {isMobile && (
                <Box sx={{ position: "relative", padding: "15px" }}>
                  <Chip
                    label="FREE"
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 3,
                      right: 3,
                      zIndex: 2,
                      fontSize: "0.65rem",
                      height: 18,
                      fontWeight: 700,
                      color: "white",
                      background: "linear-gradient(135deg, #22c55e, #16a34a)",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                    }}
                  />

                  <Box
                    onClick={handleClick}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "6px 14px",
                      backgroundColor: "primary.main",
                      color: "white",
                      borderRadius: "8px",
                      fontWeight: 500,
                      cursor: "pointer",
                      fontSize: "0.9rem",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                    }}
                  >
                    Post property
                  </Box>
                </Box>
              )}

              {/* ================= DESKTOP / TABLET VIEW ================= */}
              {!isMobile && (
                <>
                  {/* Add Property */}
                  <Box sx={{ position: "relative" }}>
                    <Chip
                      label="FREE"
                      size="small"
                      sx={{
                        position: "absolute",
                        top: -8,
                        right: -10,
                        zIndex: 2,
                        fontSize: "0.65rem",
                        height: 18,
                        fontWeight: 700,
                        color: "white",
                        background: "linear-gradient(135deg, #22c55e, #16a34a)",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                      }}
                    />

                    <Box
                      onClick={handleClick}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "6px 14px",
                        backgroundColor: "primary.main",
                        color: "white",
                        borderRadius: "8px",
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: "1rem",
                        "&:hover": {
                          backgroundColor: "primary.dark",
                        },
                      }}
                    >
                      Post property
                    </Box>
                  </Box>

                  {/* Contact */}
                  <IconButton
                    onClick={(e) => setContactAnchor(e.currentTarget)}
                    sx={{
                      backgroundColor: "#19469b",
                      color: "white",
                      borderRadius: "50%",
                      width: 30,
                      height: 30,
                      outline: "2px dotted #19469b",
                      outlineOffset: "4px",
                    }}
                  >
                    <CallIcon fontSize="small" />
                  </IconButton>

                  {/* Profile */}
                  <ProfileScreen />
                </>
              )}
            </Box>
            {/* Login Modal */}
            {openLoginModal && (
              <LoginModal
                onClose={() => setOpenLoginModal(false)}
                referralCode={referralCode}
                redirectPath={location.pathname + location.search}
              />
            )}
          </Box>
        </Toolbar>

        <Popover
          open={openContact}
          anchorEl={contactAnchor}
          onClose={handleContactClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          disableRestoreFocus
          sx={{
            "& .MuiPopover-paper": {
              width: 260,
              p: 2,
              borderRadius: 2,
            },
          }}
        >


          <Typography fontWeight={600} mb={1}>
            Contact Us
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
              fontSize: "0.85rem",
              color: "text.secondary",
            }}
          >
            <Typography variant="body2">
              Mon – Sun | 9:00 AM – 7:00 PM
            </Typography>
          </Box>


          {/* ===== Number 1 ===== */}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography fontWeight={500}>
              +91 9629611466
            </Typography>

            <Box display="flex" gap={1}>
              {/* Call */}
              <IconButton
                size="small"
                component="a"
                href="tel:+919629611466"
              >
                <CallIcon fontSize="small" />
              </IconButton>

              {/* WhatsApp */}
              <IconButton
                size="small"
                component="a"
                href="https://wa.me/919629611466"
                target="_blank"
              >
                <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          {/* ===== Number 2 ===== */}
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography fontWeight={500}>
              +91 6369102680
            </Typography>

            <Box display="flex" gap={1}>
              {/* Call */}
              <IconButton
                size="small"
                component="a"
                href="tel:+916369102680"
              >
                <CallIcon fontSize="small" />
              </IconButton>

              {/* WhatsApp */}
              <IconButton
                size="small"
                component="a"
                href="https://wa.me/916369102680"
                target="_blank"
              >
                <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Popover>

        <Dialog
          open={openContactMobile}
          onClose={() => setOpenContactMobile(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Slide}
          TransitionProps={{ direction: "up" }}
          sx={{
            "& .MuiDialog-paper": {
              position: "fixed",
              bottom: 0,
              margin: 0,
              width: "100%",
              borderRadius: "16px 16px 0 0",
              p: 2,
            },
          }}
        >
          {/* Drag Indicator */}
          <Box
            sx={{
              width: 40,
              height: 4,
              backgroundColor: "#ccc",
              borderRadius: 2,
              mx: "auto",
              mb: 2,
            }}
          />

          <Typography fontWeight={600} mb={1}>
            Contact Us
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
              fontSize: "0.85rem",
              color: "text.secondary",
            }}
          >
            <Typography variant="body2">
              Mon – Sun | 9:00 AM – 7:00 PM
            </Typography>
          </Box>


          {/* Number 1 */}
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography fontWeight={500}>+91 9629611466</Typography>
            <Box>
              <IconButton component="a" href="tel:+919629611466">
                <CallIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://wa.me/919629611466"
                target="_blank"
              >
                <WhatsAppIcon sx={{ color: "#25D366" }} />
              </IconButton>
            </Box>
          </Box>

          {/* Number 2 */}
          <Box display="flex" justifyContent="space-between">
            <Typography fontWeight={500}>+91 6369102680</Typography>
            <Box>
              <IconButton component="a" href="tel:+916369102680">
                <CallIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://wa.me/916369102680"
                target="_blank"
              >
                <WhatsAppIcon sx={{ color: "#25D366" }} />
              </IconButton>
            </Box>
          </Box>
        </Dialog>



      </AppBar>
    );
  }

  return (
    <AppBar
      position="fixed"
      elevation={3}
      sx={{
        padding: { xs: "0px", sm: "5px" },
        paddingTop: { xs: "4px" },
        paddingBottom: { xs: "4px" },
      }}
      style={{
        background: "white",
        borderBottom: "2px solid #bfdbfe",
        boxShadow: themeMode === "light"
          ? "0 4px 16px rgba(0, 0, 0, 0.25)"
          : "0 4px 16px rgba(239, 237, 237, 0.1)",
      }}
    >
      <Toolbar
        sx={{
          p: 0,
          pl: { xs: 2, sm: 0 },
          minHeight: "auto",
        }}
      >
        <Box sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: { xs: "4px 8px", sm: "6px 12px" },
              // backgroundColor:"red"
            }}
          >
            <Box
              component="img"
              src="/Jemins Letter Head.png"
              alt="Realty Mart Logo"
              sx={{
                display: { xs: "block", sm: "block" },
                height: { xs: 60, sm: 60 },
                width: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 0 0 transparent)"
              }}
            />

            <MUILink
              component="button"
              underline="none"
              onClick={() => {
                window.location.href = "/";
              }}
              sx={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "black",
                fontSize: { xs: "1.5rem", sm: "1.7rem" },
                fontWeight: 600,
                fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
                letterSpacing: "-0.025em",
                lineHeight: 1,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -2,
                  left: 0,
                  width: "0%",
                  height: "2px",
                  background: `linear-gradient(90deg, ${theme.primary_gradient_start_color}, ${theme.primary_gradient_end_color})`,
                  transition: "width 0.3s ease",
                },
                "&:hover::after": {
                  width: "100%",
                },
              }}
            >
              JEMINS
            </MUILink>
          </Box>

          {currentPath === "/search-properties" && (
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Paper
                component="div"
                sx={{
                  display: { xs: "none", sm: 'flex' },
                  alignItems: 'center',
                  px: 2,
                  py: 0.5,
                  width: { xs: "85%", sm: "65%", md: "55%" },
                  borderRadius: "15px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                  backgroundColor: "white",
                  transition: "all 0.2s ease",
                  "&:focus-within": {
                    boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
                    border: "1px solid #e0e0e0",
                  }
                }}
              >
                <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
                <InputBase
                  placeholder="Search properties by location, area, or name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch(e)}
                  sx={{
                    // ml: 1,
                    flex: 1,
                    fontSize: "0.95rem",
                    "& .MuiInputBase-input": {
                      padding: "8px 0",
                    }
                  }}
                />
                {/* Search Button with Loading State */}

                <GradientButton
                  text="Search"
                  onClick={handleSearch}
                  // disabled={!searchTerm.trim()}
                  width={100}
                  height={35}
                />
                {/* <Button
        variant="contained"
        onClick={handleSearch}
        disabled={!searchTerm.trim()}
        sx={{
          backgroundColor: searchTerm.trim() ? '#799EFF' : 'grey.400',
          color: 'white',
          borderRadius: '10px',
          padding: '6px 16px',
          marginLeft: 1,
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.9rem',
          minWidth: 'auto',
          '&:hover': {
            backgroundColor: searchTerm.trim() ? '#5D7CF4' : 'grey.400',
          },
          transition: 'all 0.2s ease',
        }}
      >
        Search
      </Button> */}
              </Paper>
            </Box>
          )}
          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* Notifications */}
            <IconButton onClick={handleNotificationClick}>
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsNoneIcon sx={{ color: "black", fontSize: 25 }} />
              </Badge>
            </IconButton>


          </Box>
          <Box
            className="header-icon"
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
            }}
          >
            {/* Notifications Icon with Popover */}
            <IconButton
              color="inherit"
              onClick={handleNotificationClick}
            >
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsNoneIcon sx={{ color: "black", fontSize: { xs: 25, sm: 25 }, marginLeft: { xs: "0px" } }} />
              </Badge>
            </IconButton>
            <IconButton color="inherit" component={Link} to="/favorites">

              <FavoriteBorderIcon
                sx={{
                  // color: "white",
                  color: "black",
                  fontSize: { xs: 25, sm: 25 },
                  marginLeft: { xs: "0px" },
                }}
              />

            </IconButton>

            {/* Notifications Popover */}
            <Popover
              open={notificationOpen}
              anchorEl={notificationAnchor}
              onClose={handleNotificationClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right', // Changed from 'right' to move it right
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right', // Changed from 'right' to move it right
              }}
              sx={{
                '& .MuiPopover-paper': {
                  width: { xs: '100vw', sm: 400 },
                  height: { xs: '100vh', sm: '80vh' },
                  maxHeight: { sm: '80vh' },
                  marginTop: { xs: 0, sm: 1 },
                  marginRight: { xs: 0, sm: 1 }, // Add right margin
                  borderRadius: { xs: 0, sm: 2 },
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                },
                '& .MuiBackdrop-root': {
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  backdropFilter: 'blur(2px)',
                },
              }}
            >
              <NotificationPanel
                onClose={handleNotificationClose}
                isPopover={true}
              />
            </Popover>

            {/* Call Icon */}
            <IconButton
              onClick={(e) => setContactAnchor(e.currentTarget)}
              sx={{
                backgroundColor: "#19469b",
                color: "white",
                borderRadius: "50%",
                width: 30,
                height: 30,
                outline: "2px dotted #19469b",
                outlineOffset: "4px",
                ml: 1,
              }}
            >
              <CallIcon fontSize="small" />
            </IconButton>


          </Box>


          <Box sx={{ display: { xs: "none", sm: "block" }, position: "relative", alignContent: "center", padding: "15px" }}>
            <Chip
              label="FREE"
              size="small"
              sx={{
                position: "absolute",
                top: 5,
                right: 3,
                zIndex: 2,
                fontSize: "0.65rem",
                height: 18,
                fontWeight: 700,
                color: "white",
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              }}
            />


            <Box className="nav" sx={{ display: { xs: "none", sm: "flex" } }}>
              <Box
                onClick={handleClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: "5px 10px",
                  backgroundColor: "primary.main",
                  color: "white",
                  borderRadius: "8px",
                  fontWeight: 500,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                  fontSize: { xs: "0.8rem", sm: "1rem" },
                }}
              >

                Post property
              </Box>

            </Box>


          </Box>

          {!isMobile &&
            <ProfileScreen />
          }
        </Box>

        {/* Left: Logo + Mobile Menu */}
        <Box >
          <IconButton
            edge="start"
            onClick={onDrawerToggle}
            className="menu-button"
            sx={{
              display: {
                xs: "inline-flex",
                sm: "none",
                md: "none",
                lg: "none",
              },
              color: "black"
            }}
          >
            <MenuIcon />
            <Typography>
              Menu
            </Typography>
          </IconButton>

        </Box>
      </Toolbar>


      <Popover
        open={openContact}
        anchorEl={contactAnchor}
        onClose={handleContactClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        disableRestoreFocus
        sx={{
          "& .MuiPopover-paper": {
            width: 260,
            p: 2,
            borderRadius: 2,
          },
        }}
      >

        <Typography fontWeight={600} mb={1}>
          Contact Us
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
            fontSize: "0.85rem",
            color: "text.secondary",
          }}
        >
          <Typography variant="body2">
            Mon – Sun | 9:00 AM – 7:00 PM
          </Typography>
        </Box>


        {/* ===== Number 1 ===== */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography fontWeight={500}>
            +91 9629611466
          </Typography>

          <Box display="flex" gap={1}>
            {/* Call */}
            <IconButton
              size="small"
              component="a"
              href="tel:+919629611466"
            >
              <CallIcon fontSize="small" />
            </IconButton>

            {/* WhatsApp */}
            <IconButton
              size="small"
              component="a"
              href="https://wa.me/919629611466"
              target="_blank"
            >
              <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        {/* ===== Number 2 ===== */}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography fontWeight={500}>
            +91 6369102680
          </Typography>

          <Box display="flex" gap={1}>
            {/* Call */}
            <IconButton
              size="small"
              component="a"
              href="tel:+916369102680"
            >
              <CallIcon fontSize="small" />
            </IconButton>

            {/* WhatsApp */}
            <IconButton
              size="small"
              component="a"
              href="https://wa.me/916369102680"
              target="_blank"
            >
              <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </Popover>

      <Dialog
        open={openContactMobile}
        onClose={() => setOpenContactMobile(false)}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        sx={{
          "& .MuiDialog-paper": {
            position: "fixed",
            bottom: 0,
            margin: 0,
            width: "100%",
            borderRadius: "16px 16px 0 0",
            p: 2,
          },
        }}
      >
        {/* Drag Indicator */}
        <Box
          sx={{
            width: 40,
            height: 4,
            backgroundColor: "#ccc",
            borderRadius: 2,
            mx: "auto",
            mb: 2,
          }}
        />

        <Typography fontWeight={600} mb={1}>
          Contact Us
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
            fontSize: "0.85rem",
            color: "text.secondary",
          }}
        >
          <Typography variant="body2">
            Mon – Sun | 9:00 AM – 7:00 PM
          </Typography>
        </Box>


        {/* Number 1 */}
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography fontWeight={500}>+91 9629611466</Typography>
          <Box>
            <IconButton component="a" href="tel:+919629611466">
              <CallIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://wa.me/919629611466"
              target="_blank"
            >
              <WhatsAppIcon sx={{ color: "#25D366" }} />
            </IconButton>
          </Box>
        </Box>

        {/* Number 2 */}
        <Box display="flex" justifyContent="space-between">
          <Typography fontWeight={500}>+91 6369102680</Typography>
          <Box>
            <IconButton component="a" href="tel:+916369102680">
              <CallIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://wa.me/916369102680"
              target="_blank"
            >
              <WhatsAppIcon sx={{ color: "#25D366" }} />
            </IconButton>
          </Box>
        </Box>
      </Dialog>

    </AppBar>
  );
}

export default Header;